import { cateringOrderClient } from '@/services/clients'

export default {
  getPoints() {
    return cateringOrderClient.get('/loyalty/points', undefined, {
      callerHandlesCriticalError: true,
    })
  },
}
